// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"ArticleCard_card-wrapper__2oL4O","image-wrapper":"ArticleCard_image-wrapper__26DVn"};